import API from './api';
import { exportResults } from '../utils';
import { HTTP } from '../config/http-common';

export default class Employee extends API {
    getProfile = async () => exportResults(await HTTP.get(`${this.ROUTE}/profile`));
}
